import { imageUpload } from './ImageStore';

import { imageUploadDefault } from './ImageStoreDefaults';

export const resetImageUpload = () => {
	imageUpload.set(imageUploadDefault);
};
